<template>
  <section class="spot-questions-section">
    <nav class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <p class="level-item">
          <a class="button is-primary" @click="onAdd">
            <b-icon icon="plus"></b-icon>
            <span>{{ $t('attributes.add') + $t('attributes.question') }}</span>
          </a>
        </p>
      </div>
    </nav>

    <b-table :data="questions" :loading="loading" detailed>
      <b-table-column
        field="sequence"
        :label="$t('attributes.sort')"
        :width="80"
        numeric
        v-slot="props"
      >
        {{ props.row.sequence }}
      </b-table-column>

      <b-table-column
        field="title"
        :label="$t('attributes.question')"
        v-slot="props"
      >
        {{ props.row.title }}
      </b-table-column>

      <b-table-column
        field="note"
        :label="$t('attributes.note')"
        v-slot="props"
      >
        {{ props.row.note }}
      </b-table-column>

      <b-table-column :width="200" v-slot="props">
        <div class="buttons">
          <b-button
            type="is-primary"
            outlined
            @click.prevent="onModify(props.row)"
          >
            {{ $t('attributes.modify') }}
          </b-button>
          <b-button
            type="is-danger"
            outlined
            @click.prevent="onDelete(props.row)"
          >
            {{ $t('attributes.delete') }}
          </b-button>
        </div>
      </b-table-column>

      <template #detail="props">
        <spot-list :question="props.row" :area="travelGroup.image_path" />
      </template>
    </b-table>

    <b-modal
      :active.sync="isQuestionFormModalActive"
      :can-cancel="['escape', 'x']"
      has-modal-card
    >
      <spot-question-form :question="selectedQuestion" @send="onSend" />
    </b-modal>
  </section>
</template>

<script>
import { TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import SpotQuestionForm from './SpotQuestionForm'
import SpotList from './SpotList'

export default {
  name: 'SpotQuestionsForm',
  components: { SpotQuestionForm, SpotList },
  props: {
    travelGroup: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      sending: false,

      code: this.travelGroup.code,
      questions: [],
      total: 0,

      selectedQuestion: null,
      isQuestionFormModalActive: false
    }
  },
  watch: {
    travelGroup(travelGroup) {
      this.code = travelGroup.code
      this.loadQuestionsAsync(this.code)
    }
  },
  mounted() {
    this.loadQuestionsAsync(this.code)
  },
  methods: {
    async loadQuestionsAsync(code) {
      const api = `${TRAVEL_GROUPS_API}/${code}/spot-questions`

      this.loading = true
      try {
        const res = await this.axios.get(api)
        this.questions = res.data.data
      } catch (e) {
        this.questions = []

        notifyService.fetch_error('spot_question', e)
      } finally {
        this.loading = false
      }
    },
    onAdd() {
      this.selectedQuestion = {}
      this.isQuestionFormModalActive = true
    },
    onModify(item) {
      this.selectedQuestion = item
      this.isQuestionFormModalActive = true
    },
    onSend(item) {
      if (!item.id) {
        this.createQuestion(item)
      } else {
        this.updateQuestion(item)
      }
    },
    onDelete(item) {
      this.$buefy.dialog.confirm({
        message: this.$t('attributes.confirm_delete'),
        onConfirm: () => {
          this.deleteQuestion(item)
        }
      })
    },
    async createQuestion(item) {
      const api = `${TRAVEL_GROUPS_API}/${this.code}/spot-questions`

      this.sending = true
      try {
        const res = await this.axios.post(api, item)
        const _item = res.data.data

        const questions = [...this.questions, _item]
        this.questions = questions.sort((a, b) => a.sequence - b.sequence)

        this.isQuestionFormModalActive = false

        notifyService.success(`${this.$t('attributes.add_succeed')}`)
      } catch (e) {
        notifyService.create_error(e)
      } finally {
        this.sending = false
      }
    },
    async updateQuestion(item) {
      const api = `${TRAVEL_GROUPS_API}/spot-questions/${item.id}`

      this.sending = true
      try {
        const res = await this.axios.put(api, item)
        const _item = res.data.data

        const idx = this.questions.findIndex(s => s.id === _item.id)
        const questions = [...this.questions]
        questions[idx] = _item
        this.questions = questions.sort((a, b) => a.sequence - b.sequence)

        this.isQuestionFormModalActive = false

        notifyService.success(`${this.$t('attributes.update_succeed')}`)
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    async deleteQuestion(item) {
      const api = `${TRAVEL_GROUPS_API}/spot-questions/${item.id}`

      this.sending = true
      try {
        await this.axios.delete(api)
        this.questions = this.questions.filter(i => i.id !== item.id)
        notifyService.success(`${this.$t('attributes.delete_succeed')}`)
      } catch (e) {
        notifyService.delete_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style lang="scss">
.spot-questions-section {
  .b-table {
    .table {
      tr.detail {
        .detail-container {
          background-color: white;
          padding: 0.5rem;

          .level {
            padding-bottom: 0;
            margin-bottom: 0.5rem;
          }
        }
      }
    }
  }
}
</style>
